import React, { useEffect, useState } from 'react'
import { getDataWithTypeForSelect } from '../../../lib/parameters'
import { addData, updateData, getStudentIdData } from '../../../lib/studentcurriculumtable'

export default function GlobalCurriculumTable({slug , isStudent=false}) {
    const [selectedCells, setSelectedCells] = useState([])
    const [parameters, setParameters] = useState([])
    //const [selected, setSelected] = useState([])
    const [recId, setRecId] = useState(0)
    const [show, setShow] = useState(false);
  
     const months = [
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May'
    ]
  
    async function GetParameterData() {
      const info = await getDataWithTypeForSelect('CIRCULUM')
      setParameters(info)
      //console.log("infoooooo", info)
    }
  
    async function GetSelectedData() {
      // const info = await getStudentIdData(id)
      const info = await getStudentIdData(slug)
      console.log("info", info);
      //setSelected(info)
      if (info.length > 0)
      {
      setSelectedCells(info[0].jdata);
      setRecId(info[0].id);
      }
      //console.log("info",info);
    }
  
  
    useEffect(() => {
      GetParameterData()
      GetSelectedData()
      setShow(false)
    }, [])
  
  
    const buttonClick = async () => {
  
      if (recId > 0) {
        await updateData({
          id: recId,
          jdata: selectedCells
        });
      }
      else {
        await addData({
          studentId: slug,
          jdata: selectedCells
        });
      }

      setShow(true);
      window.scrollTo(0, 0);
    }
  
    const handleCellClick = (month, itemIndex) => {
      const cellIdentifier = `${month}-${itemIndex}`;
      const isSelected = selectedCells.includes(cellIdentifier);
      console.log("Click", isSelected);
  
      if (isSelected) {
        setSelectedCells(selectedCells.filter((id) => id !== cellIdentifier))
      } else {
        setSelectedCells([...selectedCells, cellIdentifier])
      }
  
  
    }
  
    const messages = () => {
        return (<div className="alert alert-success alert-dismissible fade show" role="alert">
        <strong>Data Updated...</strong> {/*You should check in on some of those fields below.*/}
        <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"
        onClick={e => setShow(false)}></button>
      </div>)
      }

    return (
      <div className="comman-space p-0 card wish-card">
        <div className='curricullum_parent'>
          <h3 className='text-center curriculum_title'>Curriculum Table</h3>
          {show ? messages() : ""}
          <table className='curricullum_table'>
            <thead>
              <tr className='borderRadius'>
                <th>Curriculum</th>
                {months.map((month, index) => (
                  <th key={index}>{month}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {parameters.map((item, itemIndex) => (
                <tr key={item.value}>
                  <td>{item.label}</td>
                  {months.map((month, monthIndex) => {
                    const cellIdentifier = `${month}-${item.value}`
                    const isSelected = selectedCells.includes(cellIdentifier)
                    //console.log("selectedCells",isSelected);
                    return (
                      <td
                        key={cellIdentifier}
                        className={isSelected ? 'selected' : ''}
                        onClick={() => handleCellClick(month, item.value)}
                      ></td>
                    )
                  })}
                </tr>
              ))}
            </tbody>
          </table>
          {isStudent ? "" : <div className="update-profile d-flex justify-content-between">
            <button onClick={() => buttonClick()} className="btn btn-primary">
              Update
            </button>
          </div>}
          
        </div>
      </div>
    )
  }
